import { render, staticRenderFns } from "./tweet.vue?vue&type=template&id=3b612d4f&scoped=true&"
import script from "./tweet.vue?vue&type=script&lang=js&"
export * from "./tweet.vue?vue&type=script&lang=js&"
import style0 from "./tweet.vue?vue&type=style&index=0&id=3b612d4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b612d4f",
  null
  
)

export default component.exports